import { ReactNode, useCallback } from "react";

import {
	BlacklistGateLead,
	useBlacklistOverrideGate,
} from "@/components/BlacklistOverride/useBlacklistOverrideGate";

interface LeadSendGate {
	/**
	 * Resolves `true` when the chat may send to the lead: it is not blacklisted, or the user just
	 * confirmed taking it off the blacklist. `false` when they cancelled, or the lead may not be
	 * taken off (an unsubscribe, a Signalist-wide entry) — nothing is sent then.
	 */
	clearToSend: () => Promise<boolean>;
	/** Render this inside the chat. */
	overrideModal: ReactNode;
}

/**
 * The chat composer's Send — an Inbox reply, a Compose or Review-to-send message, the lead panel's
 * chat — writes to a blacklisted lead only on purpose (PREC-2548). Extracted from `useAddInboxChat`,
 * which may not grow; the decision itself is the shared `useBlacklistOverrideGate`.
 */
export const useLeadSendGate = (lead?: BlacklistGateLead | null): LeadSendGate => {
	const { gate, overrideModal } = useBlacklistOverrideGate();

	const clearToSend = useCallback(() => gate(lead ? [lead] : [], () => undefined), [gate, lead]);

	return { clearToSend, overrideModal };
};
